

//Api locale
//export const API_URL = "https://localhost:7092/api/"

//Api de test
//export const API_URL = "https://lines-test-app.azurewebsites.net/api/"

//Api de prod
export const API_URL = "https://linesapp.azurewebsites.net/api/"

export default { API_URL };